import moment from 'moment';

import { APIcaller, APIcallerv2 } from './APIcaller';

import { DATE_DISPLAY_FORMATS } from '../commons/DatePickers/constants';

const getStoreSupplierProductMappingsOfStore = async (
  storeId,
  startDate = moment().startOf('day').format(DATE_DISPLAY_FORMATS.DASHED_YEAR_MONTH_DAY),
  filterByUserCatalog = false,
  withTranslations = false,
) =>
  APIcaller.apiGet(
    `/admin/stores/${storeId}/store-supplier-product-mappings?startDate=${startDate}&filterByUserCatalog=${filterByUserCatalog}&withTranslations=${withTranslations}`,
  );

const getStoreSupplierProductMappingsOfAccountStores = async (accountId, supplierProductId) =>
  APIcallerv2.apiGet(`/accounts/${accountId}/stores/storeSupplierProductMappings`, {
    supplierProductId,
  });

const deleteMultipleStoreSupplierProductMapping = async (
  sspmIds,
  isOnlyDeletingNextAvailabilities = false,
) =>
  APIcaller.apiDelete('/admin/store-supplier-product-mappings', {
    sspmIds,
    isOnlyDeletingNextAvailabilities,
  });

const createMultipleStoreSupplierProductMapping = async (mappings) =>
  APIcaller.apiPost('/admin/store-supplier-product-mappings', { mappings });

const patchStoreSupplierProductMappingByIds = async (mappingIds, fields) =>
  APIcaller.apiPatch('/admin/store-supplier-product-mappings', {
    sspmIds: mappingIds,
    fields,
  });

const getByStoreIds = async (
  storeIds,
  supplierProductIdsToIgnore = [],
  onlyAvailableInStocks = null,
) =>
  APIcaller.apiPost('/admin/store-supplier-product-mappings/get-by-store-ids', {
    storeIds,
    supplierProductIdsToIgnore,
    onlyAvailableInStocks,
  });

export const storeSupplierProductMapping = {
  getStoreSupplierProductMappingsOfStore,
  getStoreSupplierProductMappingsOfAccountStores,
  createMultipleStoreSupplierProductMapping,
  deleteMultipleStoreSupplierProductMapping,
  patchStoreSupplierProductMappingByIds,
  getByStoreIds,
};
